import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { isUserAuthenticated } from '@/core/apiConfig';
import { isMobile } from '@/core/platform';
import { RootState } from '@/store';
import { GleapManager } from './gleapManager';
import { TrackingManager } from './trackingManager';

export const useGleap = () => {
  const user = useSelector((store: RootState) => store.user);
  const org = useSelector((store: RootState) => store.org);
  const [userIdentified, setUserIdentified] = useState(false);
  const [leadIdentified, setLeadIdentified] = useState(false);

  useEffect(() => {
    // Skip Gleap initialization on mobile devices
    if (isMobile()) {
      return;
    }
    GleapManager.init();
  }, []);

  useEffect(() => {
    // Skip Gleap on mobile devices
    if (isMobile()) {
      return;
    }

    const isAuthenticated = isUserAuthenticated();

    if (
      isAuthenticated &&
      !userIdentified &&
      user?.userId &&
      user?.email &&
      user?.displayName &&
      org?.name
    ) {
      GleapManager.identifyUser({
        userId: user.userId,
        displayName: user.displayName,
        email: user.email,
        org: org.name,
        permission: user.permission,
        phoneNumber: user.phoneNumber,
        title: user.title,
        role: user.role,
      });
      // Load user stats once per session and push to Mixpanel/Gleap
      TrackingManager.loadUserStatsOnce();
      setUserIdentified(true);
      setLeadIdentified(false);
    }
  }, [user, org, userIdentified]);

  useEffect(() => {
    // Skip Gleap on mobile devices
    if (isMobile()) {
      return;
    }

    const isAuthenticated = isUserAuthenticated();

    if (!isAuthenticated && !leadIdentified && !userIdentified) {
      GleapManager.identifyLead();
      setLeadIdentified(true);
    }
  }, [leadIdentified, userIdentified]);

  return {};
};
